import React from 'react';

export function Tabs({ tabs, atual, onChange }) {
  return (
    <div className="crm-tabs">
      {tabs.map((t) => (
        <button key={t.id} className={`crm-tab${atual === t.id ? ' active' : ''}`} onClick={() => onChange(t.id)}>
          {t.label}
        </button>
      ))}
    </div>
  );
}

export default Tabs;
